/** @format */

import {CartesianGrid, ResponsiveContainer, XAxis, ComposedChart} from 'recharts';

import {XAsisRoot as Root} from './style';
import {XAxisDataList} from '../../model/xAxis';
import {CommonChartData} from '../../model/charts';
import CustomXAxisLabel from './components/CustomXAxisLabel';
import {FilteredXAxis, MonthMarker} from './components/MonthMarker';
import {MarginOptions} from '../../model/common';

interface Props {
  xAxisDataList: XAxisDataList;
  chart?: CommonChartData[];
  syncId?: string;
  height: number;
  margin: MarginOptions;
}

const XAxisWithGrid = ({syncId, xAxisDataList, chart, height, margin}: Props) => {
  const filteredXAxis: FilteredXAxis[] = Object.keys(xAxisDataList)
    .filter(key => xAxisDataList[key].month)
    .map(key => ({
      name: key,
      month: xAxisDataList[key].month!,
    }));

  const monthsInterval = filteredXAxis.length > 1 ? 'preserveStartEnd' : 0;

  return (
    <Root height={height}>
      <ResponsiveContainer>
        <ComposedChart data={chart} syncId={syncId} margin={margin}>
          <CartesianGrid horizontal={false} stroke='#48494d' />

          {/*Числа*/}

          <XAxis
            dataKey='name'
            orientation='top'
            axisLine={false}
            tickLine={false}
            tick={props => <CustomXAxisLabel {...props} xAxisDataList={xAxisDataList} />}
            tickFormatter={value => {
              return value.slice(2);
            }}
            interval='preserveStartEnd'
            height={15}
          />

          {/*Месяца*/}

          <XAxis
            xAxisId='month'
            dataKey='name'
            orientation='top'
            axisLine={false}
            tickLine={false}
            tick={props => <MonthMarker {...props} data={filteredXAxis} />}
            ticks={filteredXAxis.map(k => k.name)}
            tickFormatter={value => {
              // Нужно, чтобы увеличить физбокс изначального значения
              return `00${value}`;
            }}
            interval={monthsInterval}
            height={15}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Root>
  );
};

export default XAxisWithGrid;
